'use strict';

wbApp.factory('messageBoxSvc', ['$translate', '$modal', '$rootScope', '$sce', 'tenantSettingSvc', 'userSettingSvc', '$timeout',
    function ($translate, $modal, $rootScope, $sce, tenantSettingSvc, userSettingSvc, $timeout) {


        //#region Message Dialog

        //var m = {
        //    title: '',
        //    message: '',
        //    input: [true|false],
        //    buttons: [{
        //        text: 'TXT_BTN_CANCEL',
        //        callback: cancel
        //    }, {
        //        text: 'TXT_BTN_OK',
        //        callback: ok
        //    }]
        //};

        function showMessageDlg(dlgConfig) {
            // fill in missing callbacks and primary settings
            var hasPrimaryBtn = false;

            for (var i = 0; i < dlgConfig.buttons.length; i++) {
                var button = dlgConfig.buttons[i];
                if (!button.callback) {
                    button.callback = function () { }
                }
                if (button.primary) {
                    hasPrimaryBtn = true;
                }
                if (!hasPrimaryBtn && (i + 1) === dlgConfig.buttons.length) {
                    button.primary = true;                    
                }               

                button.$onClick = _.bind(function () {
                    messageDlg.$scope.isBusy = true;
                    var promise = this.callback();
                    if (!!promise && !!promise.then) {
                        promise.then(function () {
                            messageDlg.$scope.isBusy = false;
                            messageDlg.$scope.$hide();
                        }, function () {
                            messageDlg.$scope.isBusy = false;
                            messageDlg.$scope.$hide();
                        });
                    } else {                       
                        messageDlg.$scope.isBusy = false;
                        messageDlg.$scope.$hide();
                    }
                    
                }, button);
            }

            var messageDlg = $modal({
                templateUrl: 'message-box/message-dialog.html',
                show: false,
                scope: $rootScope.$new(),
                container: '#message-box-container'
            });
            
            messageDlg.$promise.then(function () {                
                messageDlg.$scope.dlgConfig = angular.copy(dlgConfig);
                messageDlg.$scope.dlgConfig.inputModel = "";
                messageDlg.$scope.isBusy = false;
                messageDlg.$scope.dlgConfig.translatedMessage = $translate.instant(dlgConfig.message);
                messageDlg.$scope.inputModel = messageDlg.$scope.dlgConfig.inputModel;
                messageDlg.$scope.inputOnChange = function(data) {
                    messageDlg.$scope.inputModel = data;
                    messageDlg.hide();
                };
                messageDlg.$scope.$on('modal.show.before', function() {
                    if (dlgConfig.onShowBefore) {
                        dlgConfig.onShowBefore();
                    }
                });
                messageDlg.$scope.$on('modal.show', function() {
                    if (dlgConfig.onShow) {
                        dlgConfig.onShow();
                    }
                    $timeout(function() {
                        $('#msg-dlg-input input').focus();    
                    }, 100);
                });
                messageDlg.$scope.$on('modal.hide.before', function() {
                    if (dlgConfig.onHideBefore) {
                        dlgConfig.onHideBefore();
                    }
                });
                messageDlg.$scope.$on('modal.hide', function() {
                    if (dlgConfig.onHide) {
                        dlgConfig.onHide( messageDlg.$scope.dlgConfig.inputModel);
                    }
                });
                messageDlg.show();
            });
        }

        //#endregion

        //#region Confirm Client notification

        // var m = {
        //                   Email, SMS
        //    userSetting: [string, string],
        //    callback: function() { } 
        // }
        //
        // userSettingName:
        // ConfimNotificationCourseStudent
        // ConfimNotificationCourseRegistrationPayment
        // ConfirmNotificationCourseInterest
        // ConfirmNotificationSchedule
        // ConfirmNotificationSmsSchedule

        function showConfirmClientNotification(dlgConfig) {

            var emailsEnabled = 
                tenantSettingSvc.settings.sendEmailsToClients &&
                !tenantSettingSvc.settings.disableAllEmails &&
                !tenantSettingSvc.settings.disableAllEmailsExceptUserRegistration;

            var smsEnabled = tenantSettingSvc.settings.enableSMSSupport;

            var userSettingRemembered = true;

            angular.forEach(dlgConfig.userSetting, function(item) {
                userSettingRemembered = userSettingRemembered && 
                    (userSettingSvc.settings[item] === true || userSettingSvc.settings[item] === false);
            });

            if (!emailsEnabled && (!smsEnabled || dlgConfig.userSetting.length === 1) || userSettingRemembered) {
                dlgConfig.callback({
                    sendEmailNotification: emailsEnabled && !!userSettingSvc.settings[dlgConfig.userSetting[0]],
                    sendSmsNotification: smsEnabled && !!userSettingSvc.settings[dlgConfig.userSetting[1]]
                });
                return;
            }

            var defaultConfig = {
                showSendEmailNotification: emailsEnabled,
                showSendSmsNotification: smsEnabled && dlgConfig.showSendSmsNotification,
                showRememberSendNotification: true,
                sendEmailNotification:emailsEnabled,
                sendSmsNotification: false,
                rememberSendNotification: false
            };

            var messageDlg = $modal({
                templateUrl: 'message-box/confirm-client-notification.html',
                show: false,
                scope: $rootScope.$new()
            });

            function saveSetting(setting) {
                if (messageDlg.$scope.dlgConfig.rememberSendNotification) {

                    userSettingSvc.settings[dlgConfig.userSetting[0]] = setting.sendEmailNotification;
                    if (dlgConfig.userSetting.length === 2) {
                        userSettingSvc.settings[dlgConfig.userSetting[1]] = setting.sendSmsNotification;
                    }

                    userSettingSvc.saveAsync();
                }
            }

            messageDlg.$promise.then(function () {
                messageDlg.$scope.dlgConfig = defaultConfig;
                messageDlg.$scope.onNoClick = function () {

                    let setting = {
                        sendEmailNotification: false,
                        sendSmsNotification: false
                    };
                    
                    saveSetting(setting);
                    dlgConfig.callback(setting);
                };
                messageDlg.$scope.onYesClick = function () {

                    let setting = {
                        sendEmailNotification: messageDlg.$scope.dlgConfig.sendEmailNotification,
                        sendSmsNotification: messageDlg.$scope.dlgConfig.sendSmsNotification
                    };
                    saveSetting(setting);
                    dlgConfig.callback(setting);
                };

                messageDlg.show();
            });
        }

        //#endregion

        //#region Progress Percent Dialog

        function showPctProgress(title, message) {
            var pctProgressDlg = $modal({
                templateUrl: 'message-box/pct-progress-dialog.html',
                show: false,
                scope: angular.extend($rootScope.$new(), {
                    title: null,
                    message: null,
                    progressPct: 0,
                    progressMessages: [],
                    disableCloseButton: true
                })
            });

            pctProgressDlg.$promise.then(function () {
                pctProgressDlg.$scope.title = $translate.instant(title);
                pctProgressDlg.$scope.message = $translate.instant(message);
                pctProgressDlg.$scope.progressPct = 0;
                pctProgressDlg.$scope.noOfErrors = 0;

                pctProgressDlg.show();
            });

            // progress: {
            //   pctProgress: 88,
            //   progressMsg: 'OK - xyz',
            //   status: 0|1|2 - 0 OK, 1 Error, 2 Done
            // }
            return function (progress) {
                pctProgressDlg.$scope.progressPct = Math.ceil(progress.pctProgress);
                
                pctProgressDlg.$scope.progressMessages.push(progress);
                
                if (progress.status === 1) {
                    pctProgressDlg.$scope.noOfErrors += 1;
                }

                if (progress.pctProgress >= 100) {
                    pctProgressDlg.$scope.disableCloseButton = false;
                }
            }
        }

        //#endregion

        return {
            showPctProgress: showPctProgress,
            showMessageDlg: showMessageDlg,
            showConfirmClientNotification: showConfirmClientNotification
        }
    }]);

